module.exports = __webpack_public_path__ + "static/media/Aeffchen_haengend.b3352f1f.svg";